import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FilterService } from '@core/services/filter/filter.service';
import { mobileFilterAnimation } from '@features/product-filter/mobile-filter/mobile-filter.animation';
import { facetGroupToParam } from '@features/product-filter/product-filter.functions';
import { ImpactOverlayRef } from '@libs/overlay';
import { Facet, FacetConfigResponse as FacetGroup } from '@models/api-search.models';
import { ReplaceKeyPipe } from '@features/product-filter/pipes/replace-key.pipe';
import { ActiveFacetsNamesPipe } from '@features/product-filter/pipes/active-facets-names.pipe';
import { HasActiveFacetsPipe } from '@features/product-filter/pipes/has-active-facets.pipe';
import { FacetGroupsWithValuesPipe } from '@features/product-filter/pipes/facet-groups-with-values.pipe';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { LoadingDotsComponent } from '@shared/loading-dots/loading-dots.component';
import { FormsModule } from '@angular/forms';
import { SvgIconComponent } from '@shared/svg-icon/svg-icon.component';
import { NgIf, NgFor, NgClass, AsyncPipe } from '@angular/common';
import { DialogSidebarComponent } from '../../dialog/dialog-sidebar/dialog-sidebar.component';

@Component({
    selector: 'app-mobile-filter',
    templateUrl: './mobile-filter.component.html',
    styleUrls: ['./mobile-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [mobileFilterAnimation],
    imports: [
        DialogSidebarComponent,
        NgIf,
        NgFor,
        SvgIconComponent,
        FormsModule,
        NgClass,
        LoadingDotsComponent,
        AsyncPipe,
        TranslateSafePipe,
        FacetGroupsWithValuesPipe,
        HasActiveFacetsPipe,
        ActiveFacetsNamesPipe,
        ReplaceKeyPipe
    ]
})
export class MobileFilterComponent {
    public activeGroup: FacetGroup | null = null;

    constructor(
        public filterService: FilterService,
        public readonly overlayRef: ImpactOverlayRef
    ) {}

    public onChange(): void {
        if (this.activeGroup?.key && this.activeGroup?.values?.length) {
            const param = facetGroupToParam(this.activeGroup.key, this.activeGroup.values);
            this.filterService.update(param);
        }
    }

    public trackFacetFn(index: number, group: FacetGroup): string {
        return group.key || `group-${index}`;
    }

    public trackFacetValueFn(index: number, facet: Facet): string {
        return facet.key || `facet-${index}`;
    }

    public reset(): void {
        this.filterService.reset({ take: this.filterService.defaultTakeAmount });
        // Reset active group since it has no coupling
        // to the filter dataset
        this.activeGroup?.values?.forEach(value => (value.selected = false));
    }
}
